import store from "@/store";
import emitter from "@/utils/mitt";
import router from "@/router";
//公共方法
// import publicMethod from "@/utils/publicMethod.js";
import { getItem, setItem, removeItem } from "@/utils/storage";
import { ElNotification } from 'element-plus'
let ws;
let mapCallback = {};
let SEQ = 0;
let reconnection = 0;
let websocketTime = null;
let websocketConnectTimer = null;

export function registerWebsocket() {
  console.log("registerWebsocket");
  if (!ws) return;
  sendWebsocket(
    "webapi/ws_login",
    { token: store.state.user },
    function (err, json) {
      if (err) {
        return console.log("websocket 注册失败: " + err.message);
      }
      if (!json || json.code != 0) {
        if (json.code == 1016 || json.code == 1017) {
          websocket.websocketOut();
          if (!store.state.user)
            return (window.location.href = store.state.ip + "#/login");
        }
        return console.log("websocket 注册失败: " + (json.msg || "未知原因"));
      }
    }
  );
}

export function registerHotelWebsocket() {
  console.log("registerHotelWebsocket");
  if (!ws) return;
  sendWebsocket(
    "webapi/ws_on",
    { token: store.state.user, type: 4, hotel_id: store.state.id },
    function (err, json) {}
  );
}

export function closeHotelWebsocket() {
  console.log("closeHotelWebsocket");
  if (!ws) return;
  sendWebsocket(
    "webapi/ws_off",
    { token: store.state.user, type: 4, hotel_id: store.state.id },
    function (err, json) {}
  );
}

export function createWebsocket() {
  console.log("createWebsocket");
  if (!store.state.user) {
    reconnection = 0;
    return false;
  }
  reconnection++;
  ws = new WebSocket("wss://mp.sznetsky.cn");
  // ws = new WebSocket("ws://ctc2.morequick.cn:5200");
  ws.id = Date.now();
  setItem("websocketId", ws.id);
  // publicMethod.addNotification("创E客房云管","websocket创建:"+ws.id);
  ws.onopen = function () {
    console.log("服务器已连接");
    reconnection = 0;
    if (websocketConnectTimer) {
      clearTimeout(websocketConnectTimer);
      websocketConnectTimer = undefined;
    }
    registerWebsocket();
    registerHotelWebsocket();
  };
  ws.onclose = function (e) {
    console.log("服务器连接已断开");
    // publicMethod.addNotification("创E客房云管","websocket断开:"+ws.id);
    if (store.state.user) {
      let websocketId = +getItem("websocketId") || 0;
      // publicMethod.addNotification("创E客房云管","websocket重连:"+websocketId+"\n"+ws.id);
      if (websocketId <= ws.id) {
        websocketConnection();
      }
    }
  };
  ws.onmessage = function (e) {
    //服务器返回的数据
    let text = (e.data || "") + "";
    if (!text) return;
    // console.log(text);
    try {
      //eg: {"type":1,"seq":2,"data":{"code":0,"data":"ok"}}
      let json = JSON.parse(text);
      if (!json) return;
      let type = +json.type || 1, //消息类型
        seq = json.seq, //消息ID，唯一，由客户端发往服务端，服务端回应的时候会带上
        data = json.data; //消息数据
      switch (type) {
        //api 结果
        case 1:
          if (!seq) return;
          //触发回调处理
          let t = mapCallback[seq];
          if (t) {
            if (t.timer) clearTimeout(t.timer);
            if (t.callback) t.callback(undefined, data);
          }
          mapCallback[seq] = undefined;
          return;
        //消息通知
        case 2:
          //TODO: 处理消息通知
          console.log(data);
          if (data.code == 0) {
            ElNotification({
              title: data.data.name,
              dangerouslyUseHTMLString: true,
              showClose: false,
              message: data.data.content.replaceAll("\n", "<br>"),
              offset: 60
            })
            emitter.emit("message", data.data);
          }
          return;
        //错误提示
        case 3:
          console.log(data); //eg: {"code":1017,"msg":"账号已在其它地方登录"}
          if (data.code == 2215) {
            websocketClose();
          }
          return;
        case 4:
          console.log(data); //eg: {"code":1017,"msg":"账号已在其它地方登录"}
          if (data.code == 0) {
            emitter.emit("hotelMessage", data.data);
          }
          return;
      }
    } catch (e) {}
  };
}

export function initWebsocket() {
  console.log("initWebsocket");
  if (!ws || store.state.webSocketState != "open") {
    // publicMethod.addNotification("创E客房云管","websocket初始化");
    createWebsocket();
  } else {
    registerWebsocket();
  }
}

/**
 * 发送 websocket 数据
 * @param {string} url api 地址
 * @param {Object} data 参数对象
 * @param {Function} cb 回调函数(err,data)
 */
export function sendWebsocket(url, data, cb) {
  if (ws.readyState != WebSocket.OPEN)
    return cb && cb(new Error("服务器连接已断开"));
  let params = {
    seq: ++SEQ,
    url: url,
    data: data,
  };
  //3秒无返回数据，视为超时
  let timer = setTimeout(function () {
    cb && cb(new Error("请求已超时: " + url));
    mapCallback[params.seq] = cb = undefined;
  }, 3000);
  mapCallback[params.seq] = { callback: cb, timer: timer };
  //发送数据到 websocket 服务器
  ws.send(JSON.stringify(params));
}

/**
 * websocket 重新连接
 */
export function websocketConnection() {
  console.log("websocketConnection");
  if (reconnection <= 10) {
    websocketConnectTimer = setTimeout(createWebsocket, 2000);
  } else {
    reconnection = 0;
  }
}

/**
 * websocket websocketping
 */
export function websocketPing() {
  clearTimeout(websocketTime);
  websocketTime = setTimeout(() => {
    ws.send("PING");
    websocketPing();
  }, 10 * 1000);
}

/**
 * websocket 关闭
 */
export function websocketClose() {
  closeHotelWebsocket();
  ws.close();
  window.location.href = store.state.ip + "#/login";
}

/**
 * websocket 退出
 */
export function websocketOut() {
  closeHotelWebsocket();
  ws.close();
}

//将方法暴露出来
export default {
  sendWebsocket,
  createWebsocket,
  websocketClose,
  initWebsocket,
  websocketOut,
  registerHotelWebsocket,
  closeHotelWebsocket,
};
